import React from 'react';
import PropTypes from 'prop-types';

export default function InformativeIcon(props) {
  const { width, height } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 18 18'>
      <g id='Grupo_151741' data-name='Grupo 151741' transform='translate(-3690 20897)'>
        <g
          id='Placement_Area'
          data-name='Placement Area'
          transform='translate(3690 -20897)'
          fill='red'
          stroke='rgba(0,0,0,0)'
          strokeWidth='1'
          opacity='0'
        >
          <rect width={width} height={height} stroke='none' />
          <rect x='0.5' y='0.5' width='17' height='17' fill='none' />
        </g>
        <path
          id='Caminho_103028'
          data-name='Caminho 103028'
          d='M9,1a8,8,0,1,0,8,8A8,8,0,0,0,9,1ZM8.85,3.15a1.359,1.359,0,0,1,1.431,1.283q0,.065,0,.129A1.332,1.332,0,0,1,8.85,5.994,1.353,1.353,0,0,1,7.418,4.561a1.359,1.359,0,0,1,1.3-1.412Q8.785,3.146,8.85,3.15ZM11,13.5a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5H8V9H7.5A.5.5,0,0,1,7,8.5v-1A.5.5,0,0,1,7.5,7h2a.5.5,0,0,1,.5.5V12h.5a.5.5,0,0,1,.5.5Z'
          transform='translate(3690 -20897)'
          fill='#2c7dd9'
        />
      </g>
    </svg>
  );
}

InformativeIcon.defaultProps = {
  fill: '#fff',
  width: 12.003,
  height: 11.998
};

InformativeIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
